import { Link } from 'react-router-dom';
import Shiitake from 'shiitake';
import * as React from 'react';
import { TemplateCardOuterDiv, TemplateThumb, TextTruncate, ThumbInfo } from '../styles/TemplateCard';
import LazyLoad from 'react-lazyload';

import { TemplateData } from '../App';
import { WindowSizeBreakpoints, DesktopLazyLoadOffset, MobileLazyLoadOffset } from './Consts';

interface TemplateProps {
    template: TemplateData;
    basePath: string;
}

export class TemplateCard extends React.Component<TemplateProps, any> {
    constructor(props: TemplateProps) {
        super(props);
    }

    render () {
        const description = this.props.template.description;
        const lazyLoadOffset: number = window.innerWidth > WindowSizeBreakpoints.SMALL ? DesktopLazyLoadOffset : MobileLazyLoadOffset;

        return (
            <div className={ 'col-xs-12 col-sm-4' }>
                <Link className="no-underline" to={ this.props.basePath + this.props.template.slug }>
                    <TemplateCardOuterDiv className={ 'shadow-sm' }>
                        <TemplateThumb>
                            <LazyLoad height="200px" once={ true } offset={ lazyLoadOffset }>
                                <img className={ 'img-responsive' } src={ this.props.template.thumbnail_url } />
                            </LazyLoad>
                        </TemplateThumb>
                        <ThumbInfo>
                            <TextTruncate className={ 'h4 btm-6' }>{ this.props.template.name }</TextTruncate>
                            <Shiitake lines={ 2 } className="small semibold btm-0" tagName="p">
                                { description }
                            </Shiitake>
                        </ThumbInfo>
                    </TemplateCardOuterDiv>
                </Link>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/TemplateCard.tsx